<form (ngSubmit)="onSubmit()">
  <div class="search-container">
    <div class="search-header">
      @if (showQuickFilters) {
        <div class="inline-filters">
          @if (showOutreachQuickFilter) {
            <app-filter
              [filterBy]="outreachFilterBy"
              [filterByOptions]="outreachFilterOptions"
              [label]="'Outreach Form Status'"
              (filterByChanged)="outreachFilterChanged.emit($event)"
            ></app-filter>
          }
          @if (showLoanQuickFilter) {
            <app-filter
              [filterBy]="loanFilterBy"
              [filterByOptions]="loanFilterOptions"
              [label]="'Filled Pre Lending Information Form'"
              (filterByChanged)="loanFilterChanged.emit($event)"
            ></app-filter>
          }
        </div>
      }
      @if (showAdvancedToggle) {
        <div class="search-actions">
          <a
            class="advanced-search-toggle"
            (click)="toggleAdvancedSearch()"
            href="javascript:void(0)"
            title="Advanced Filters"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path
                d="M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"
              />
            </svg>
            <span>Advanced Filters</span>
            <span class="arrow">
              @if (isAdvancedSearchVisible) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
                  />
                </svg>
              } @else {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
                  />
                </svg>
              }
            </span>
            @if (showIndicator) {
              <div class="filled-indicator">{{ count }}</div>
            }
          </a>
        </div>
      }
    </div>
    @if (isAdvancedSearchVisible) {
      <div class="advanced-search" id="tour-advanced-search">
        <div class="form-row">
          <!-- <div class="form-group">
            <label for="applicationStatus">Application Status</label>
            <select
              id="applicationStatus"
              [(ngModel)]="searchForm.application_status"
              name="applicationStatus"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.application_status"
            >
              <option value="" selected>Select Status</option>
              <option value="In Progress">In Progress</option>
              <option value="Funded">Funded</option>
              <option value="Grant Funding">Grant Funding</option>
            </select>
          </div> -->
          <div class="form-group">
            <label for="address">Address</label>
            <input
              id="address"
              type="text"
              placeholder="Enter Address"
              [(ngModel)]="searchForm.address"
              name="address"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.address"
            />
          </div>
          <div class="form-group">
            <label for="disbursedAmount">Disbursed Amount</label>
            <div class="input-group">
              <input
                id="disbursedAmount"
                type="number"
                [(ngModel)]="searchForm.disbursedAmount"
                name="disbursedAmount"
                placeholder="Enter disbursed amount"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.disbursedAmount"
              />
              <select
                id="disbursedAmountOperator"
                [(ngModel)]="searchForm.disbursedAmountOperator"
                name="disbursedAmountOperator"
                [class.searched-field]="searchForm.disbursedAmountOperator"
              >
                <option value="" selected>Select</option>
                <option value="greater">Greater than</option>
                <option value="less">Less than</option>
              </select>
            </div>
            @if (
              (searchForm.disbursedAmount &&
                !searchForm.disbursedAmountOperator) ||
              (!searchForm.disbursedAmount &&
                searchForm.disbursedAmountOperator)
            ) {
              <div class="error-message">
                Both disbursed amount and condition must be selected.
              </div>
            }
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="Enter email"
              [(ngModel)]="searchForm.primary_email"
              name="email"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.primary_email"
            />
          </div>
          <div class="form-group">
            <label for="estimatedDamageValue">Estimated Damage Value</label>
            <div class="input-group">
              <input
                id="estimatedDamageValue"
                type="number"
                [(ngModel)]="searchForm.estimatedDamageValue"
                name="estimatedDamageValue"
                placeholder="Enter damage value"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.estimatedDamageValue"
              />
              <select
                id="estimatedDamageValueOperator"
                [(ngModel)]="searchForm.estimatedDamageValueOperator"
                name="estimatedDamageValueOperator"
                [class.searched-field]="searchForm.estimatedDamageValueOperator"
              >
                <option value="" selected>Select</option>
                <option value="greater">Greater than</option>
                <option value="less">Less than</option>
              </select>
            </div>
            @if (
              (searchForm.estimatedDamageValue &&
                !searchForm.estimatedDamageValueOperator) ||
              (!searchForm.estimatedDamageValue &&
                searchForm.estimatedDamageValueOperator)
            ) {
              <div class="error-message">
                Both damage value and condition must be selected.
              </div>
            }
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="estimatedRevenueLoss">Estimated Revenue Loss</label>
            <div class="input-group">
              <input
                id="estimatedRevenueLoss"
                type="number"
                [(ngModel)]="searchForm.estimatedRevenueLoss"
                name="estimatedRevenueLoss"
                placeholder="Enter revenue loss"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.estimatedRevenueLoss"
              />
              <select
                id="estimatedRevenueLossOperator"
                [(ngModel)]="searchForm.estimatedRevenueLossOperator"
                name="estimatedRevenueLossOperator"
                [class.searched-field]="searchForm.estimatedRevenueLossOperator"
              >
                <option value="" selected>Select</option>
                <option value="greater">Greater than</option>
                <option value="less">Less than</option>
              </select>
            </div>
            @if (
              (searchForm.estimatedRevenueLoss &&
                !searchForm.estimatedRevenueLossOperator) ||
              (!searchForm.estimatedRevenueLoss &&
                searchForm.estimatedRevenueLossOperator)
            ) {
              <div class="error-message">
                Both revenue loss and condition must be selected.
              </div>
            }
          </div>
          <!-- <div class="form-group">
            <label for="ethnicity">Ethnicity</label>
            <select
              id="ethnicity"
              [(ngModel)]="searchForm.ethnicity"
              name="ethnicity"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.ethnicity"
            >
              <option value="" selected>Select Ethnicity</option>
              <option value="Prefer not to answer">Prefer not to answer</option>
              <option value="Not Hispanic or Latino">
                Not Hispanic or Latino
              </option>
              <option value="Hispanic or Latino">Hispanic or Latino</option>
            </select>
          </div> -->
          <!-- <div class="form-group">
            <label for="gender">Gender</label>
            <select
              id="gender"
              [(ngModel)]="searchForm.gender"
              name="gender"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.gender"
            >
              <option value="" selected>Select Gender</option>
              <option value="Prefer not to answer">Prefer not to answer</option>
              <option value="Female">Female</option>
              <option value="Male">Male</option>
              <option value="Female-to-Male">
                Transgender Male/Trans Man/Female-to-Male
              </option>
              <option value="Male-to-Female">
                Transgender Female/Trans Woman/Male-to-Female
              </option>
              <option value="Gender Non-Conforming">
                Gender Non-Conforming
              </option>
              <option value="Non-binary">Nonbinary</option>
              <option value="Other">Other</option>
            </select>
          </div> -->
          <div class="form-group">
            <label for="grantSize">Grant Size</label>
            <div class="input-group">
              <input
                id="grantSize"
                type="number"
                [(ngModel)]="searchForm.grantSize"
                name="grantSize"
                placeholder="Enter grant size"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.grantSize"
              />
              <select
                id="grantSizeOperator"
                [(ngModel)]="searchForm.grantSizeOperator"
                name="grantSizeOperator"
                [class.searched-field]="searchForm.grantSizeOperator"
              >
                <option value="" selected>Select</option>
                <option value="greater">Greater than</option>
                <option value="less">Less than</option>
              </select>
            </div>
            @if (
              (searchForm.grantSize && !searchForm.grantSizeOperator) ||
              (!searchForm.grantSize && searchForm.grantSizeOperator)
            ) {
              <div class="error-message">
                Both grant size and condition must be selected.
              </div>
            }
          </div>
          <div class="form-group">
            <label for="grossRevenue2023">Gross Revenue in 2023</label>
            <div class="input-group">
              <input
                id="grossRevenue2023"
                type="number"
                [(ngModel)]="searchForm.grossRevenue2023"
                name="grossRevenue2023"
                placeholder="Enter revenue"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.grossRevenue2023"
              />
              <select
                id="grossRevenue2023Operator"
                [(ngModel)]="searchForm.grossRevenue2023Operator"
                name="grossRevenue2023Operator"
                [class.searched-field]="searchForm.grossRevenue2023Operator"
              >
                <option value="" selected>Select</option>
                <option value="greater">Greater than</option>
                <option value="less">Less than</option>
              </select>
            </div>
            @if (
              (searchForm.grossRevenue2023 &&
                !searchForm.grossRevenue2023Operator) ||
              (!searchForm.grossRevenue2023 &&
                searchForm.grossRevenue2023Operator)
            ) {
              <div class="error-message">
                Both revenue and condition must be selected.
              </div>
            }
          </div>
          <div class="form-group">
            <label for="operatingStatus">Operating Status</label>
            <select
              id="operatingStatus"
              [(ngModel)]="searchForm.operating_status"
              name="operatingStatus"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.operating_status"
            >
              <option value="" selected>Select</option>
              <option value="Fully-reopened/back to normal operations">
                Fully-reopened/back to normal operations
              </option>
              <option
                value="Partially open, but not back to normal/full operations"
              >
                Partially open, but not back to normal/full operations
              </option>
              <option
                value="Closed, but planning to reopen within the next month"
              >
                Closed, but planning to reopen within the next month
              </option>
              <option value="Closed, plan to reopen but not sure when">
                Closed, plan to reopen but not sure when
              </option>
              <option value="Closed, don't plan to reopen">
                Closed, don't plan to reopen
              </option>
            </select>
          </div>
        </div>

        <div class="form-row">
          <!-- <div class="form-group">
            <label for="womanLed">Is the Business Woman-Led?</label>
            <select
              id="womanLed"
              [(ngModel)]="searchForm.woman_led"
              name="womanLed"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.woman_led"
            >
              <option value="" selected>Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div> -->
          <div class="form-group">
            <label for="ownerName">Owner Name</label>
            <input
              id="ownerName"
              type="text"
              placeholder="Enter owner name"
              [(ngModel)]="searchForm.owner_name"
              name="ownerName"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.owner_name"
            />
          </div>
          <div class="form-group">
            <label for="packageId">Package ID</label>
            <input
              id="packageId"
              type="text"
              placeholder="Enter package ID"
              [(ngModel)]="searchForm.package_id"
              name="packageId"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.package_id"
            />
          </div>
          <div class="form-group">
            <label for="phoneNumber">Phone Number</label>
            <input
              id="phoneNumber"
              type="text"
              placeholder="Enter phone number"
              [(ngModel)]="searchForm.phone_number"
              name="phoneNumber"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.phone_number"
            />
          </div>
          <div class="form-group">
            <label for="preferredLanguage">Preferred Language</label>
            <select
              id="preferredLanguage"
              [(ngModel)]="searchForm.preferred_language"
              name="preferredLanguage"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.preferred_language"
            >
              <option value="" selected>Select language</option>
              <option value="English">English</option>
              <option value="Spanish">Spanish</option>
            </select>
          </div>
          <!-- <div class="form-group">
            <label for="ownerDisabled">Owner Disabled</label>
            <select
              id="ownerDisabled"
              [(ngModel)]="searchForm.disability_status"
              name="ownerDisabled"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.disability_status"
            >
              <option value="" selected>Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div> -->
        </div>

        <div class="form-row">
          <!-- <div class="form-group">
            <label for="race">Race</label>
            <select
              id="race"
              [(ngModel)]="searchForm.race"
              name="race"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.race"
            >
              <option value="" selected>Select Race</option>
              <option value="Asian">Asian American</option>
              <option value="White">White</option>
              <option value="Black or African American">
                Black or African American
              </option>
              <option value="Prefer not to answer">Prefer Not to Answer</option>
              <option value="Native American">Native American</option>
              <option value="Pacific Islander">Pacific Islander</option>
              <option value="Native Hawaiian">Native Hawaiian</option>
              <option value="Alaskan Native">Alaskan Native</option>
            </select>
          </div> -->
          <div class="form-group">
            <label for="requestedFundAmount">Requested Fund Amount</label>
            <div class="input-group">
              <input
                id="requestedFundAmount"
                type="number"
                [(ngModel)]="searchForm.requestedFundAmount"
                name="requestedFundAmount"
                placeholder="Enter amount"
                (ngModelChange)="checkFormValidity()"
                [class.searched-field]="searchForm.requestedFundAmount"
              />
              <select
                id="requestedFundAmountOperator"
                [(ngModel)]="searchForm.requestedFundAmountOperator"
                name="requestedFundAmountOperator"
                [class.searched-field]="searchForm.requestedFundAmountOperator"
              >
                <option value="" selected>Select</option>
                <option value="greater">Greater than</option>
                <option value="less">Less than</option>
              </select>
            </div>
            @if (
              (searchForm.requestedFundAmount &&
                !searchForm.requestedFundAmountOperator) ||
              (!searchForm.requestedFundAmount &&
                searchForm.requestedFundAmountOperator)
            ) {
              <div class="error-message">
                Both amount and condition must be selected.
              </div>
            }
          </div>
          <!-- <div class="form-group">
            <label for="sexualOrientation">Sexual Orientation</label>
            <select
              id="sexualOrientation"
              [(ngModel)]="searchForm.sexual_orientation"
              name="sexualOrientation"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.sexual_orientation"
            >
              <option value="" selected>Select Orientation</option>
              <option value="Prefer not to answer">Prefer not to answer</option>
              <option value="Straight/Heterosexual">
                Straight/Heterosexual
              </option>
              <option value="Gay or Lesbian">Gay or Lesbian</option>
              <option value="Bisexual or Pansexual">
                Bisexual or Pansexual
              </option>
              <option value="Queer">Queer</option>
              <option value="Don't know">Don't know</option>
              <option value="Other">Other</option>
            </select>
          </div> -->
          <div class="form-group">
            <label for="zipCode">ZIP Code</label>
            <input
              id="zipCode"
              type="text"
              placeholder="Enter ZIP code"
              [(ngModel)]="searchForm.postal_code"
              name="zipCode"
              (ngModelChange)="checkFormValidity()"
              [class.searched-field]="searchForm.postal_code"
            />
            @if (
              (searchForm.postal_code?.length ?? 0) > 0 &&
              (searchForm.postal_code?.length ?? 0) < 5
            ) {
              <div class="error-message">
                ZIP Code must be at least 5 digits.
              </div>
            }
          </div>
        </div>

        <div class="form-row-buttons">
          <div class="form-note">
            Note: Business industry filter will be available in WNCSBI II
            applications.
          </div>
          <div class="form-actions">
            <a
              href="javascript:void(0)"
              (click)="onSubmit()"
              class="search-button"
              [class.disabled]="!isFormValid || hasErrorMessages()"
              >Search</a
            >
            <a
              href="javascript:void(0)"
              class="reset-button"
              (click)="isShowAllData()"
            >
              Reset
            </a>
          </div>
        </div>
      </div>
    }
  </div>
</form>
